import { render, staticRenderFns } from "./homeDashboardFigures.vue?vue&type=template&id=e06bea2a&scoped=true"
import script from "./homeDashboardFigures.vue?vue&type=script&lang=js"
export * from "./homeDashboardFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bea2a",
  null
  
)

export default component.exports